import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { ButtonSelect, ButtonTextSelectControl } from '../../../Select'
import { QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_AGE } from '../../DashboardBirdview.constants.qa'
import { getBirdviewAttentionAgeOption } from '../../DashboardBirdview.utils'
import { getBirdviewAgeRangeLabelParams } from '../../DashboardBirdview.utils.charts'

import { getBirdviewAttentionAgeOptions } from './BirdviewAttentionRowAgeSelect.utils'

import * as styles from './BirdviewAttentionRowAgeSelect.module.css'

function BirdviewAttentionRowAgeSelect({ age, onSelect }) {
  const { t } = useTranslation()

  function handleSelectItem(option) {
    onSelect(getBirdviewAttentionAgeOption(option.value))
  }

  return (
    <ButtonSelect
      Control={ButtonTextSelectControl}
      controlProps={{
        buttonProps: {
          Button: Button.Outlined,
          height: BUTTON_HEIGHT_32,
          text: t(age.labelKey, getBirdviewAgeRangeLabelParams(age)),
        },
      }}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomEnd,
        maxWidthByRef: false,
      }}
      dropdownProps={{ className: styles.dropdown }}
      filter={null}
      listProps={{ headerProps: { Search: null } }}
      options={getBirdviewAttentionAgeOptions(t)}
      qaName={QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_AGE}
      value={age}
      onSelectItem={handleSelectItem}
    />
  )
}

export default BirdviewAttentionRowAgeSelect
